import { useEffect, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { AttributeTargetType } from "../Data/WBData";

import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import  { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetBusinessServiceCategories,GetBusinessClassCategories } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { CategoryFilterData, CategoryFilterStatus, CategorySelector, CheckCategory, ClassCategoryFilterData } from "./CategorySelector";
import { DownCaret } from "../Icons/Carets";


type filterConfiguration = {

  catIdField:string,
  catTitleField:string,
  itemListField:string,
  itemIdField:string,
  itemSaveIdField:string,
  itemTitleField:string,

  labelPlural:string,
  labelSingle:string
}

export default function ServiceFilterField({
  label,
  definition,
  layoutObject,
  updateFunc,
  saveFunc,
  screenSize,
  siteData,
  filterClasses
}: AttributeFieldProps&{filterClasses?:boolean} ) {



  let location = getNodeComponentAttributeValue(layoutObject,componentAttributeTypes.multiLocation,siteData.userContext.businessId);
  let filterString = getNodeComponentAttributeValue(layoutObject,definition.attKey,"[]");

  let parsedFilters = JSON.parse(filterString) as CategoryFilterData[];

  const [data,setData] = useState<any>(null);
  const [categories,setCategories] = useState<CheckCategory[]>([]);
  const [numSelected,setNumSelected] = useState<number>(0);
  const [isExpanded,setIsExpanded] = useState<boolean>(false);

  const isClasses = filterClasses??false;


  const config:filterConfiguration = (isClasses)?
  {
    catIdField:"classCategoryIDs",
    catTitleField:"CategoryName",
    itemListField:"Services",
    itemIdField:"classIds",
    itemSaveIdField:"classId",
    itemTitleField:"classTitle",
    labelPlural:"Classes",
    labelSingle:"Class"

  }
  :
  {
    catIdField:"serviceCategoryIDs",
    catTitleField:"CategoryName",
    itemListField:"Services",
    itemIdField:"serviceIds",
    itemSaveIdField:"serviceIds",

    itemTitleField:"serviceTitle",
    labelPlural:"Services",
    labelSingle:"Service"

  }


  useEffect(()=>{

    const onGetData=(data:any)=>{
      setData(data);
      let cats = mapDataToCategories(data,parsedFilters);
      setCategories(cats);

      setNumSelected(getNumSelected(cats));
    }

    if(isClasses){
      GetBusinessClassCategories(siteData.userContext,location,onGetData);
    }
    else
      GetBusinessServiceCategories(siteData.userContext,location,onGetData);

  // eslint-disable-next-line
  },[])


  const mapDataToCategories = (data:any,filters?:CategoryFilterData[])=>{


    const cats: CheckCategory[] = [];

    /*
      if there are filters grab the default filter.
      set the default check value for this catgories items to the default filter value
      if it's mixed, then change the default value on each item 

    */
    for(let i = 0;i<data.length;i++){

      let cat = data[i];
      let newCat:CheckCategory = {name:cat.CategoryName,items:[],id:cat[config.catIdField]};

      let defaultChecked = true;
      let filter = null;

      if(filters){
        filter = filters.find(f=>f.id==cat[config.catIdField]);
       
        if(filter){
           if( filter.status == CategoryFilterStatus.All){
           defaultChecked = true;
          }  
          else if(filter.status == CategoryFilterStatus.None){
            defaultChecked = false;
          }
        }
      }

      for(let s = 0;s<cat[config.itemListField].length;s++){

        if(filter && filter.status == CategoryFilterStatus.Some){
          defaultChecked = filter.included.includes(cat[config.itemListField][s][config.itemIdField]);
        }

        newCat.items.push({name:cat[config.itemListField][s][config.itemTitleField],checked:defaultChecked,id:cat[config.itemListField][s][config.itemIdField],saveID:cat[config.itemListField][s][config.itemSaveIdField]});

      }

      cats.push(newCat);
    }

  
    return cats;

  }


  const createFilterFromCategories = (categories:CheckCategory[])=>{
    const filters:CategoryFilterData[] = [];

    for(let i = 0;i<categories.length;i++){
      let cat = categories[i];
      let filter:CategoryFilterData = {id:cat.id,included:[],status:CategoryFilterStatus.None};

      let numChecked = 0;

      for(let s = 0;s<cat.items.length;s++){
        let item = cat.items[s];
        if(item.checked){
          numChecked++;
          filter.included.push(item.id);
        }
      }

      if(numChecked == cat.items.length){
        filter.status = CategoryFilterStatus.All;
        filter.included = [];//we don't need to save the ids since all are already selected
      }
      else if(numChecked == 0){
        filter.status = CategoryFilterStatus.None;
      }
      else{
        filter.status = CategoryFilterStatus.Some;
      }

      filters.push(filter);
    }

    return filters;


  }

  const createClassFilterFromCategories = (categories:CheckCategory[])=>{


    let filter:ClassCategoryFilterData = {included:[],excluded:[]};
    for(let i = 0;i<categories.length;i++){
      let cat = categories[i];
 

      for(let s = 0;s<cat.items.length;s++){
        let item = cat.items[s];
        if(item.checked){



          filter.included.push(item.saveID??item.id);
        }
        else{
          filter.excluded.push(item.saveID??item.id);
        }
      }
    }

      if(filter.included.length>filter.excluded.length||filter.excluded.length == 0){
        filter.included = [];
      }
      else if(filter.excluded.length>filter.included.length){
        filter.excluded = [];
      }
      return filter;

  }

 


  const getNumSelected = (categories:CheckCategory[])=>{

    let numSelected = 0;

    for(let i = 0;i<categories.length;i++){
      let cat = categories[i];
      for(let s = 0;s<cat.items.length;s++){
        let item = cat.items[s];
        if(item.checked){
          numSelected++;
        }
      }
    }

    return numSelected;

  }



  let total = 0;
  for(let i = 0;i<categories.length;i++){
    let cat = categories[i];
    total += cat.items.length;
  }

  let isAll = numSelected >= total;

  let numText = (isAll)?"All":numSelected.toString();

  return  <div className={"wb-input-group" }>
    
          <div className="flex-row justify-between cursor-pointer" style={{fontSize:"14px",padding:"4px 0px"}} onClick={()=>{
            

            if(!isExpanded){
              setTimeout(()=>{
                let el = document.getElementById("category-filter-input");
                if(el){
                  el.focus();
                }
              },10)
            }
            setIsExpanded(!isExpanded)
            
            
            
            }}>
            <div>{config.labelPlural}</div>
            <span className="flex-row gap-med" style={{paddingRight:"4px"}}>
              <span>{(data!=null?numText:"...")} {numSelected==1&&total>1?config.labelSingle:config.labelPlural} </span>
              <div style={{fontSize:"10px",transform:(!isExpanded?"rotateZ(-90deg)":""),transition:".2s"}}>
                <DownCaret/>
              </div>
            
            </span>
          </div>
        { isExpanded&&
          <div>
          {
            data != null ?
             <CategorySelector catagories={categories} 
             onUpdate={(cats)=>{
              let filters = createFilterFromCategories(cats);

              //save dif filters for classes vs services.
                if(!isClasses){
                  updateFunc(componentAttributeTypes.filters,JSON.stringify(filters),AttributeTargetType.Component);
                }
                else{
                  let cFilters = createClassFilterFromCategories(cats);
          
                  updateFunc(componentAttributeTypes.filters,JSON.stringify(cFilters),AttributeTargetType.Component);
                }
                //save for the layout to use correctly
                updateFunc(definition.attKey,JSON.stringify(filters),AttributeTargetType.Component);
                setNumSelected(getNumSelected(cats));
                
             }}
             />:
             <div className="w-full " style={{opacity:".75",padding:"24px 0px",fontSize:"14px"}}>Loading...</div>

               }
        </div>
        }
            </div>
  
}
